export default {
  message: {
    "error": "อุ๊ปส์! เกิดข้อผิดพลาดบางอย่าง.",
    "Sorrysomeerrorsoccurred": "เกิดข้อผิดพลาดที่ไม่คาดคิด คุณสามารถลองเปลี่ยนภาษา หรือออกแล้วเริ่มแอปใหม่.",
    "quit": "ออก",
    "language": "ภาษา",
    "Youcanchangethelanguagehere": "คุณสามารถเปลี่ยนภาษาได้ที่นี่!",
    "current": "ปัจจุบัน",
    "home": "หน้าแรก",
    "friends": "เพื่อน",
    "wallet": "กระเป๋าเงิน",
    "aboutus": "เกี่ยวกับเรา",
    "Sharewithfriends": "แชร์กับเพื่อน",
    "copyFailure": "คัดลอกไม่สำเร็จ",
    "copySuccess": "คัดลอกสำเร็จ",
    "Claimreward": "รับรางวัล",
    "DailyLogin": "เข้าสู่ระบบรายวัน",
    "noInvitationsYet": "ยังไม่มีการเชิญชวน",
    "LoadMore": "โหลดเพิ่มเติม",
    "WatchAD": "ดูโฆษณา",
    "continue": "ดำเนินการต่อ",
    "Congratulations": "ขอแสดงความยินดี",
    "MyFriends": "เพื่อนของฉัน",
    "Invitefriends": "เชิญเพื่อน",
    "Invitepremiumfriends": "เชิญเพื่อนพรีเมียม",
    "DailyTasks": "งานรายวัน",
    "inviteDesc": "+{num} ${name} สำหรับเพื่อนแต่ละคนที่คุณเชิญ",
    "DailyTasksDesc": "ทำภารกิจเพื่อรับ airdrop เพิ่มเติม",
    "SponsorsandPartners": "ผู้สนับสนุนและพันธมิตร",
    "Receivingwallet": "กระเป๋าเงินที่รับ",
    "Enterwalletaddress": "กรอกที่อยู่กระเป๋าเงิน {name}",
    "Claim": "รับ",
    "Booster": "บูสเตอร์",
    "RentPeriod": "ระยะเวลาการเช่า",
    "days30": "30 วัน",
    "Dailyprofit": "กำไรต่อวัน",
    "Totalprofit": "กำไรรวม",
    "Quantity": "จำนวน",
    "RentPrice": "ราคาเช่า",
    "RentMiner": "เช่าเครื่องขุด",
    "Insufficient": "ไม่มีผู้เข้าร่วมเพียงพอ",
    "InsufficientMsg": "คุณต้องเชิญ {num} เพื่อนเพื่อรับอุปกรณ์เสริมเพิ่มเติม.",
    "Settings": "ตั้งค่า",
    "copyid": "คัดลอก ID",
    "UpgradeSuccessfully": "อัปเกรดสำเร็จ",
    "Name": "ชื่อ",
    "userinfo": "ข้อมูลผู้ใช้",
    "disconnect": "หลุดการเชื่อมต่อ",
    "Startmining": "เริ่มการขุด",
    "Welcome": "ยินดีต้อนรับสู่ {name}",
    "Withdrawal": "การถอนเงิน",
    "Minimumamount": "จำนวนเงินขั้นต่ำ",
    "Networkfee": "ค่าธรรมเนียมเครือข่าย",
    "Enteramount": "กรอกจำนวนเงิน",
    "Submit": "ส่ง",
    "MinimumTip": "จำนวนเงินที่ถอนน้อยเกินไป จำนวนเงินขั้นต่ำในการถอน: {num}",
    "MaximumTip": "จำนวนไม่เพียงพอ จำนวนเงินสูงสุดที่คุณสามารถถอนคือ: {num}",
    "SubmittedTip": "ส่งข้อมูลแล้ว คาดว่าจะดำเนินการภายใน 30-60 วันทำการ",
    "WebSubmittedTip": "ส่งข้อมูลแล้ว เราจะดำเนินการให้เร็วที่สุด",
    "WithdrawStatus": "สถานะ",
    "Submissiontime": "เวลาส่งข้อมูล",
    "WithdrawAwaitTip": "* คาดว่าจะใช้เวลา 30-60 วันทำการ การเชิญเพื่อนมากขึ้นสามารถเร่งกระบวนการตรวจสอบได้",
    "WebWithdrawAwaitTip": "* คาดว่าจะใช้เวลา 24-48 ชั่วโมง การเชิญเพื่อนมากขึ้นสามารถเร่งกระบวนการตรวจสอบได้",
    "Processing": "กำลังดำเนินการ",
    "Success": "สำเร็จ",
    "Rejection": "ถูกปฏิเสธ",
    "Amount": "จำนวนเงิน",
    "Numberoffriends": "จำนวนเพื่อน: {now}/{limit}",
    "InviteTip": "ในการถอนเงินครั้งแรก คุณต้องเชิญ {limit} เพื่อนเข้าร่วมแอปขุด",
    "openonphone": "เปิดลิงก์นี้บนโทรศัพท์ของคุณ",
    "claimTip": "จำนวนเงินที่สามารถรับได้ต่ำเกินไป จำนวนเงินขั้นต่ำในการรับคือ: {num}",
    "WalletBalance": "ยอดเงินในกระเป๋าเงิน",
    "Withdraw": "ถอนเงิน",
    "SetWalletAddress": "ตั้งค่าที่อยู่กระเป๋าเงิน",
    "WithdrawalRecord": "บันทึกการถอนเงิน",
    "Norecords": "ไม่มีบันทึก",
    "Whatis": "{name} คืออะไร?",
    "All": "ทั้งหมด",
    "save": "บันทึก",
    "successWithdrawal": "สแกนสำเร็จ {num}",
    "secondsago": "{time} วินาทีก่อน",
    "Loading": "กำลังโหลด...",
    "PaymentConfirming": "กำลังตรวจสอบสถานะธุรกรรม...",
    "Check": "ตรวจสอบ",
    "CheckFail": "ธุรกรรมไม่เสร็จสมบูรณ์ กรุณาตรวจสอบอีกครั้งใน 5 วินาที",
    "Addname": "เพิ่ม '{name}' ไปยังชื่อของคุณ",
    "Restattcheck": "เริ่มต้นแอปใหม่เพื่อตรวจสอบ",
    "Copyname": "คัดลอก '{name}'",
    "SubmissionFailed": "การส่งข้อมูลล้มเหลว กรุณาลองอีกครั้งในภายหลัง",
    "WithdrawalReview": "การตรวจสอบการถอนเงิน",
    "select_payment_method": "เลือกวิธีการชำระเงิน",
    "total_amount": "จำนวนเงินรวม",
    "next_step": "ขั้นตอนถัดไป",
    "creating_order": "กำลังสร้างคำสั่งซื้อ...",
    "order_created": "คำสั่งซื้อถูกสร้างขึ้น",
    "order_status": "สถานะการสั่งซื้อ",
    "order_id": "หมายเลขคำสั่งซื้อ",
    "order_amount": "จำนวนเงินคำสั่งซื้อ",
    "order_status_desc": "คำอธิบายสถานะคำสั่งซื้อ",
    "payment_cancelled": "การชำระเงินถูกยกเลิก",
    "opening_payment": "กำลังเปิดการชำระเงิน...",
    "payment_success": "การชำระเงินสำเร็จ",
    "payment_failed": "การชำระเงินล้มเหลว",
    "payment_pending": "รอการชำระเงิน",
    "payment_processing": "กำลังดำเนินการชำระเงิน",
    "create_order_failed": "สร้างคำสั่งซื้อไม่สำเร็จ",
    "creating_ton_order": "กำลังสร้างคำสั่งซื้อ TON...",
    "check_payment_status": "กำลังตรวจสอบสถานะการชำระเงิน...",
    "use_ton_payment": "ใช้การชำระเงิน TON",
    "connect_wallet": "เชื่อมต่อกระเป๋าเงิน",
    "start_transaction": "เริ่มทำธุรกรรม",
    "address": "ที่อยู่",
    "amount_ton": "จำนวน TON",
    "copy": "คัดลอก",
    "comment_memo": "หมายเหตุความคิดเห็น",
    "comment_memo_desc": "กรุณาใส่หมายเหตุความคิดเห็น",
    "comment_memo_placeholder": "ใส่หมายเหตุความคิดเห็น",
    "amount": "จำนวน",
    "wallet_address": "ที่อยู่กระเป๋าเงิน",
    "you_can_choose_to_connect_wallet_to_pay": "คุณสามารถเลือกเชื่อมต่อกระเป๋าเงินเพื่อชำระเงิน",
    "or_manually_transfer_to_the_above_address": "หรือโอนเงินไปยังที่อยู่ข้างต้นด้วยตนเอง (โปรดทราบว่าจำนวนและหมายต้องเหมือนกันอย่างแน่นอน)",
    "transaction_success": "ธุรกรรมสำเร็จ",
    "transaction_failed": "ธุรกรรมล้มเหลว",
    "transaction_error": "ข้อผิดพลาดในการทำธุรกรรม",
    "transaction_status": "สถานะธุรกรรม",
    "transaction_id": "หมายเลขธุรกรรม",
    "transaction_amount": "จำนวนธุรกรรม",
    "transaction_status_desc": "คำอธิบายสถานะธุรกรรม",
    "miner_detail": "รายละเอียดนักขุด",
    "rent_period": "ระยะเวลาการเช่า",
    "days": "{days} วัน",
    "daily_yield": "ผลตอบแทนรายวัน",
    "total_yield": "ผลตอบแทนรวม",
    "invite_friends": "เชิญเพื่อน",
    "price": "ราคา",
    "rent": "เช่า",
    "free_claim": "รวบรวมรางวัลฟรี",
    "redeem": "แลก",
    "buy": "เช่า",
    "invite_friends_not_enough": "เชิญเพื่อนไม่เพียงพอ",
    "redeem_success": "แลกสำเร็จ",
    "redeem_failed": "แลกล้มเหลว",
    "rent_success": "เช่าสำเร็จ",
    "rent_failed": "เช่าล้มเหลว",
    "TotalPower": "พลังงานรวม",
    "MaxQuantity": "เติบโตจนถึงค่าฝั่งสูงสุดแล้ว",
    "Running": "กำลังทำงาน",
    "Stop": "หยุด",
    "Withdrawalunlock": "การปลดล็อกการถอน",
    "Close": "ปิด",
    "Delivering": "กำลังส่ง",
    "Duetothelargenumber": "เนื่องจากจำนวนผู้รับที่มาก, airdrop ของคุณคาดว่าจะมาถึงใน 15-20 วันทำการ",
    "WithdrawalunlockTip": "คุณต้องเชิญเพื่อน {num} เพื่อทำภารกิจ/ผูกกระเป๋าเงินเพื่อปลดล็อกการถอน",
    "mining_title": "โรบอท",
    "Upgrade": "อัปเกรด",
    "partner": "พันธมิตร",
    "faq": "คำถามที่พบบ่อย",
    "task": "งาน",
    "OpenRobot": "เปิดหุ่นยนต์",
    "MyRobot": "หุ่นยนต์ของฉัน",
    "Level": "ระดับ",
    "Commission": "ค่าคอมมิชชั่น",
    "DirectFriends": "เพื่อนตรง",
    "Feedback": "ข้อเสนอแนะแน่นอน",
    "Pleaseenteryouremailaddress": "กรุณาใส่ที่อยู่อีเมลของคุณ",
    "Inputfeedbackcontent": "กรอกเนื้อหาข้อเสนอแนะแบบ",
    "Submitfeedback": "ส่งข้อเสนอแนะ",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "ส่งข้อเสนอแนะแบบสำเร็จ ขอบคุณสำหรับข้อเสนอแนะแบบมีค่า",
    "Feedbacksubmissionfailed,pleaseretriy": "การส่งข้อเสนอแนะแบบล้มเหลว กรุณาลองใหม่อีกครั้ง",
    "Addressformaterror": "รูปแบบที่อยู่ผิดพลาด",
    "Readclipboardfailed": "อ่านคลิปบอร์ดล้มเหลว",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "คุณได้ให้ข้อเสนอแนะแบบวันนี้แล้ว กรุณากลับมาอีกครั้งพรุ่งนี้",
    "Record": "บันทึก",
    "Newuserguidance": "ดูทัวร์ต้อนรับ",
    "Usetonwallet": "ใช้กระเป๋าเงิน TON",
    "Reward": "รางวัล",
    "Connectwallet": "เชื่อมต่อกระเป๋าเงิน",
    "Notconnected": "ไม่ได้เชื่อมต่อ",
    "Disconnect": "ตัดการเชื่อมต่อ",
    "AboutTAI": "รายละเอียดโทเคน",
    "WithdrawalRecordDesc": "บันทึกการถอน",
    "StartAItrading": "เริ่มการซื้อขาย AI",
    "Next": "ถัดไป",
    "Start": "เริ่ม",
    "WithdrawalSuccess": "ถอนสำเร็จ",
    "WithdrawalFail": "ถอนล้มเหลว",
    "Max": "สูงสุด",
    "WithdrawalRecords": "บันทึกการถอน",
    "Commissionrules": "กฎคอมมิชชั่น",
    "Mycommission": "ค่าคอมมิชชั่นของฉัน",
    "Shop": "ร้านค้า",
    "BuyDifferentAIrobots": "อัปเกรดด้วยอุปกรณ์คอมพิวเตอร์เพื่อการสแกนที่เร็วขึ้น!",
    "CurrentRunningAIrobots": "หุ่นยนต์ AI ที่กำลังทำงานปัจจุบัน",
    "DailyProfit": "กำไรประจำวัน",
    "Buy": "ซื้อ",
    "ValidityPeriod": "ระยะเวลาที่ถูกต้อง",
    "Days": "วัน",
    "Price": "ราคา",
    "APY": "APY",
    "NoRobot": "ไม่มีพลังการคอมพิวเตอร์",
    "RemainingTime": "เวลาที่เหลือ",
    "InviteandEarn": "ชวนและรับรางวัล",
    "InvitDec": "ชวนเพื่อนของคุณเข้าร่วมการซื้อขาย AI และรับค่าคอมมิชชั่น USDT และโทเค็น airdrop ร่วมกัน!",
    "ShareToGroups": "แชร์ไปยังกลุ่ม",
    "Select_payment_method": "เลือกวิธีการชำระเงิน",
    "twa_pay_tip_with_memo": "กรุณาให้แน่ใจว่า ที่อยู่, จำนวนเงิน, และหมายเหตุสอดคล้องกันสำหรับการโอนเงิน.",
    "twa_pay_tip": "กรุณาให้แน่ใจว่า ที่อยู่และจำนวนเงินถูกต้องสำหรับการโอนเงิน.",
    "twa_pay_tip_placeholder": "ใส่บันทึกความคิดเห็น",
    "twa_pay_tip_placeholder_with_memo": "ใส่บันทึกความคิดเห็นพร้อมบันทึก",
    "twa_pay_tip_placeholder_without_memo": "ใส่บันทึกความคิดเห็นโดยไม่มีบันทึก",
    "twa_pay_tip_placeholder_with_memo_placeholder": "ใส่บันทึกความคิดเห็นพร้อมบันทึก",
    "twa_pay_tip_placeholder_without_memo_placeholder": "ใส่บันทึกความคิดเห็นโดยไม่มีบันทึก",
    "realtime_ai": "การเทรด AI แบบเรียลไทม์",
    "check_transaction_status": "ตรวจสอบสถานะธุรกรรม",
    "transaction_wait": "ธุรกรรมกำลังดำเนินการ คุณสามารถออกจากแอปได้ ระบบจะแจ้งข้อความเมื่อเสร็จสิ้น.",
    "Pleaseenteravalidemailaddress": "กรุณาใส่อีเมลที่ถูกต้อง",
    "max_robot_tip": "ถึงขีดจำกัดการซื้อแล้ว — ลองแผนอื่นเพื่อทำการซื้อขายต่อ!",
    "connectFailure": "เชื่อมต่อกระเป๋าเงินล้มเหลว",
    "connectSuccess": "เชื่อมต่อกระเป๋าเงินสำเร็จ",
    "PayNow": "ชำระเงินตอนนี้",
    "min_withdrawal_amount": "จำนวนเงินขั้นต่ำในการถอนคือ {num} {coin_name}",
    "max_withdrawal_amount": "จำนวนเงินสูงสุดในการถอนคือ {num} {coin_name}",
    "balance_not_enough": "คุณไม่มียอดเงินเพียงพอสำหรับการถอนนี้",
    "Numberofgroups": "จำนวนกลุ่ม: {now}/{limit}",
    "Withdraw_success": "การถอนเงินสำเร็จ",
    "allProfit": "ผลกำรวม",
    "AnnualProfit": "ผลกำไรประจำปี",
    "ScanWallet": "สแกนกระเป๋าเงิน",
    "wallet_check": "ตรวจสอบกระเป๋าเงิน",
    "Found": "พบแล้ว",
    "ScanSpeed": "ความเร็วในการสแกน",
    "MyComputingPower": "คอมพิวเตอร์",
    "Scanning": "กำลังสแกน!",
    "WithdrawDetail": "รายละเอียดการถอนเงิน",
    "ScanSuccess": "อัตราความสำเร็จในการสแกนของคุณเพิ่มขึ้นแล้ว!",
    "TaskDescription": "ทำภารกิจให้เสร็จเพื่อเพิ่มอัตราความสำเร็จในการสแกนของคุณ!",
    "InitializingMiningSystem": "กำลังเริ่มต้นระบบสแกน...",
    "NoWithdrawalRecord": "ไม่มีประวัติการถอน",
    "Invite": "จำนวนการเชิญที่ต้องการ",
    "Free": "ฟรี",
    "Confirm": "ยืนยัน",
    "RefreshTasks": "รีเฟรชงาน",
    "NumberofGroups": "จำนวนกลุ่ม: {now}/{limit}",
    "SendMessage": "ส่งข้อความ",
    "NumberofShares": "จำนวนการแชร์: {now}/{limit}",
    "NumberofTasks": "จำนวนงาน: {now}/{limit}",
    "CompleteTask": "ทำภารกิจให้เสร็จ",
    "Accelerated": "เร่งรัด",
    "Accelerated_withdrawals_success": "การถอนเงินที่เร่งรัดสำเร็จ",
    "GoBuy": "ไปซื้อ",
    "SpeedUpScan": "เร่งความเร็ว",
    "Earnings": "รายได้",
    "learnMore": "เรียนรู้เพิ่มเติม",
    "claimSuccess": "รับรางวัลสำเร็จ",
    "claimFailed": "การรับรางวัลล้มเหลว กรุณาลองอีกครั้ง",
    "noDividends": "ไม่มีเงินปันผลให้รับ",
    "dividendsInfoFallback": "เชิญเพื่อนเพื่อรับรางวัลแนะนำ"
}};